export const SYSTEM_OPTIONS = [
    { name: '通用', value: 0 },
    { name: 'FTX', value: 1 },
    { name: '海神', value: 2 },
];